module.exports = __webpack_public_path__ + "static/media/no-purchase@2x.3a6fe438.png";